export const fastTransition = 0.2

export const defaultTransition = 0.3

export const slowTransition = 0.5

export const tween = {
  damping: 40,
  stiffness: 400,
  type: 'spring',
}

export const opacitySequence = {
  opacityEnter: {
    opacity: 1,
    transition: tween,
  },
  opacityExit: {
    opacity: 0,
    transition: {
      ...tween,
    },
  },
  opacityInitial: {
    opacity: 0,
    transition: tween,
  },
}

export const projectOpacitySequence = {
  opacityEnter: {
    opacity: 1,
    transition: tween,
  },
  opacityExit: {
    opacity: 0,
    transition: {
      ...tween,
      delay: 0.2,
    },
  },
  opacityInitial: {
    opacity: 0,
    transition: tween,
  },
}

export const opacityDelaySequence = {
  opacityDelayEnter: {
    duration: slowTransition,
    opacity: 1,
    transition: {
      ...tween,
      delay: 0.5,
    },
  },
  opacityDelayExit: {
    opacity: 0,
    transition: tween,
  },
  opacityDelayInitial: {
    duration: slowTransition,
    opacity: 0,
    transition: {
      ...tween,
      delay: 0.5,
    },
  },
}
